import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  ISearchAzureReservations,
  IAzureReservations,
} from '../../../services/azure/azureReservations/azureReservations.model';
import azureReservationsService from '../../../services/azure/azureReservations/azureReservations.service';

// Asynchronous thunk action

export const searchAzureReservations = createAsyncThunk(
  'searchAzureReservations',
  async (searchParam?: ISearchAzureReservations) => {
    const response = await azureReservationsService
      .searchAzureReservations(searchParam)
      .then((res) => {
        return res.body;
      });
    return response.data;
  }
);

export const getAzureReservationsById = createAsyncThunk(
  'getAzureReservationsById',
  async (id: number) => {
    const response = await azureReservationsService.getAzureReservationsById(id).then((res) => {
      return res.body;
    });
    return response.data;
  }
);

export const saveAzureReservations = createAsyncThunk(
  'saveAzureReservations',
  async (data: IAzureReservations) => {
    const response = await azureReservationsService.saveAzureReservations(data).then((res) => {
      return res.body;
    });
    return response;
  }
);

export const deleteAzureReservations = createAsyncThunk(
  'deleteAzureReservations',
  async (id: number) => {
    const response = await azureReservationsService.deleteAzureReservations(id).then((res) => {
      return res.body;
    });
    return response;
  }
);
